import React, { useState, useEffect, useRef } from "react";
import "./NavMenu.scss";
import { Link, useLocation } from "wouter";
import { Button } from "../../Atoms/Button/Button";
import DropdownNavbarMenu from "../../Molecules/DropdownNavbarMenu/DropdownNavbarMenu";
import onMouseOverHandler, {
	clickHandler,
} from "../../../Services/NavbarEventsHandler";
import DownArrowSvg from "../../Atoms/DownArrowSvg/DownArrowSvg";
import PlanetSvg from "../../Atoms/PlanetSvg/PlanetSvg";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import content from "./content";

const NavMenu = () => {
	const [parentLocation] = useLocation();
	const [menuContent, setMenuContent] = useState(false);
	const documentClickHandler = () => clickHandler(setMenuContent);
	const acercaLink = useRef();
	const acercaArrow = useRef();
	const industriasLink = useRef();
	const industriasArrow = useRef();
	const familiasLink = useRef();
	const familiasArrow = useRef();
	const solucionesLink = useRef();
	const solucionesArrow = useRef();
	const aliadosLink = useRef();
	const aliadosArrow = useRef();
	const recursosLink = useRef();
	const recursosArrow = useRef();
	const {setSpanishLanguage, setEnglishLanguage, language} = useLanguageCtx();
	
	const links = {
		acerca: {
			link: acercaLink,
			arrow: acercaArrow
		},
		industrias: {
			link: industriasLink,
			arrow: industriasArrow
		},
		familias: {
			link: familiasLink,
			arrow: familiasArrow
		},
		soluciones: {
			link: solucionesLink,
			arrow: solucionesArrow
		},
		aliados: {
			link: aliadosLink,
			arrow: aliadosArrow
		},
		recursos: {
			link: recursosLink,
			arrow: recursosArrow
		}
	}

	useEffect(() => {
		
		let selectedLink = false;

		if (menuContent) {
			selectedLink = links[menuContent.selectedLink];
			selectedLink.link.current.style.color = "#FFB947";
			selectedLink.arrow.current.style.fill = "#FFB947";
			document.addEventListener("click", documentClickHandler, { once: true });
		}

		return () => {
			document.removeEventListener("click", documentClickHandler, {
				once: true,
			});
			if (selectedLink.link && selectedLink.link.current) {
				selectedLink.link.current.style.color = "white";
				selectedLink.arrow.current.style.fill = "white";
			}
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [menuContent]);

	const selectHandler = (e) => {
		if(e.target.value === "ingles") {
			setEnglishLanguage();
		} else if (e.target.value === "español") {
			setSpanishLanguage();
		} 
	}

	return (
		<nav
			className="page-header--nav"
			onMouseOver={(e) => onMouseOverHandler(e, setMenuContent)}
		>
			<div className="page-header--menu-cta mb-10">
					<Button
						type="button yellow"
						content={content[language].yellow_button}
						buttonRoute="/recursos/soporte"
					/>
				<span className="flex center-content-items ml-10">
					<PlanetSvg />
				</span>
				<select
					name="language"
					id="language"
					className="navMenu--select body-14 bold c-white"
					onChange={selectHandler}
				>
					<option
						value="español"
						className="body-14 c-black"
						selected={language === "spanish"}
					>
						{content[language].option_1}
					</option>
					<option
						value="ingles"
						className="body-14 c-black"
						selected={language === "english"}
					>
						{content[language].option_2}
					</option>
				</select>
				{/* <p className="body-14 c-white ml-10">Español</p> */}
			</div>
			<ul className="page-header--menu mt-10">
				<li className="page-header--item">
					<Link
						data-content="inicio"
						href="/"
						className={`page-header--link inicio ${
							parentLocation === "/" ? "active" : ""
						}`}
					>
						{content[language].inicio}
					</Link>
				</li>
				<li className="page-header--item">
					<button
						ref={acercaLink}
						data-content="acerca"
						className={`page-header--link button-link ${
							parentLocation === "/acerca" ||
							parentLocation === "/noticias" ||
							parentLocation === "/carreras" ||
							parentLocation === "/casos-de-exito"
								? "active"
								: ""
						}`}
					>
						{content[language].about}
					</button>
					<DownArrowSvg referencia={acercaArrow} />
				</li>
				<li className="page-header--item">
					<button
						ref={industriasLink}
						data-content="industrias"
						className={`page-header--link button-link ${
							parentLocation === "/industry/equipo-pesado" ||
							parentLocation === "/industry/flota-marina" ||
							parentLocation === "/industry/construccion" ||
							parentLocation === "/industry/fuerza-laboral" ||
							parentLocation === "/industry/manejo-de-flotas" ||
							parentLocation === "/industry/distribucion" ||
							parentLocation === "/industry/transporte"
								? "active"
								: ""
						}`}
					>
						{content[language].industrias}
					</button>
					<DownArrowSvg referencia={industriasArrow} />
				</li>
				<li className="page-header--item">
					<button
						ref={familiasLink}
						data-content="familias"
						className={`page-header--link button-link ${
							parentLocation === "/family/my-tracker" ||
							parentLocation === "/family/botes" ||
							parentLocation === "/family/adultos-mayores" ||
							parentLocation === "/family/automoviles" ||
							parentLocation === "/family/motocicletas"
								? "active"
								: ""
						}`}
					>
						{content[language].familias}
					</button>
					<DownArrowSvg referencia={familiasArrow} />
				</li>
				<li className="page-header--item">
					<button
						ref={solucionesLink}
						data-content="soluciones"
						className={`page-header--link button-link ${
							parentLocation === "/solutions/g-evolution" ||
							parentLocation === "/solutions/aplicaciones-moviles" ||
							parentLocation === "/solutions/servicios" ||
							parentLocation === "/solutions/telematica"
								? "active"
								: ""
						}`}
					>
						{content[language].soluciones}
					</button>
					<DownArrowSvg referencia={solucionesArrow} />
				</li>
				<li className="page-header--item">
					<button
						ref={aliadosLink}
						data-content="aliados"
						className={`page-header--link button-link ${
							parentLocation === "/allies/negocios" ||
							parentLocation === "/allies/revendedor" ||
							parentLocation === "/allies/alianzas-claves" ||
							parentLocation === "/allies/usuario-final"
								? "active"
								: ""
						}`}
					>
						{content[language].aliados}
					</button>
					<DownArrowSvg referencia={aliadosArrow} />
				</li>
				<li className="page-header--item">
					<button
						ref={recursosLink}
						data-content="recursos"
						className={`page-header--link button-link ${
							parentLocation === "/recursos/soporte" ||
							parentLocation === "/recursos/preguntas-frecuentes" ||
							parentLocation === "/recursos/tutoriales"
								? "active"
								: ""
						}`}
					>
						{content[language].recursos}
					</button>
					<DownArrowSvg referencia={recursosArrow} />
				</li>
				<li className="page-header--item">
					<Link
						data-content="contacto"
						href="/contacto"
						className={`page-header--link ${
							parentLocation === "/contacto" ? "active" : ""
						}`}
					>
						{content[language].contacto}
					</Link>
				</li>
				{menuContent && <DropdownNavbarMenu content={menuContent.content} />}
			</ul>
		</nav>
	);
};

export default NavMenu;
